import { decorate, observable, action, runInAction } from "mobx";
import WebApi, { getErrorMessage, getValidationErrors } from "modules/WebApi";
//import { StoreInterface, RootStoreInterface } from 'interfaces';
import CommonStore from "modules/CommonStore";
import ApiClient from "./api";

class CustomersStore extends CommonStore {
    constructor(rootStore) {
        const apiClient = new ApiClient(rootStore.apiClient);
        const specification = rootStore.specifications["Customers"];
        specification.fields = specification.fields?.map((f) =>
            f.name === "search_timeout_s" ? { ...f, minValue: 1 } : f,
        );
        super(rootStore, apiClient, rootStore.specifications["Customers"]);
    }
    changingAdminError = "";
    changingAdminProgress = false;
    admin = null;
    users = [];

    async addRecord(params, isShift = true) {
        return super.addRecord({ ...params, is_departments_v2: true }, isShift);
    }

    async changeAdmin(customer_id, user_id) {
        runInAction(() => {
            this.changingAdminError = "";
            this.changingAdminProgress = true;
        });
        try {
            const data = await this.apiClient.changeAdmin({ customer_id, user_id });
            runInAction(() => {
                this.admin = data;
                this.changingAdminError = "";
                this.changingAdminProgress = false;
            });
            return data;
        } catch (e) {
            runInAction(() => {
                this.admin = null;
                this.changingAdminError = e;
                this.changingAdminProgress = false;
            });
            return null;
        }
    }

    async uploadTariffInfo(customer_id, base64) {
        const result = await this.apiClient.uploadTariffInfo(customer_id, base64);
        await this.fetchRecord(customer_id, true, true);
        return result;
    }

    async deleteTariffInfo(customer_id) {
        const result = await this.apiClient.deleteTariffInfo(customer_id);
        await this.fetchRecord(customer_id, true, true);
        return result;
    }

    async getUsers(useCache, filter) {
        if (useCache && this.users) return this.users;
        const text = filter["$nodx_search"] || "";
        const { customer_id, id } = filter || {};
        try {
            const { data } = (await this.apiClient.getUsers(customer_id, text, id)) || {};
            runInAction(() => {
                this.users = data?.users || [];
            });
            return data;
        } catch (e) {
            return null;
        }
    }
}

decorate(CustomersStore, {
    users: observable,
    getUsers: action,
});

export default CustomersStore;
